// extracted by mini-css-extract-plugin
export default {"description":"EidFK","desktop":"gYVST","mobile":"NYmpU"};